var _excluded = ["backgroundImage", "children", "className", "color", "style"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import assetResolver, { assetKeys } from 'mosaic-assets-resolver';
import { findChildByType } from "../internals/utils/reactHelpers";
import SovosHeroBannerTitle from "../sovos-hero-banner-title";
import SovosHeroBannerSubtitle from "../sovos-hero-banner-subtitle";
import SovosHeroBannerStatus from "../sovos-hero-banner-status";
import { contentSidePadding } from "../internals/page-layout/contentPadding";
var DEFAULT = 'default';
var DARK = 'dark';
var SUCCESS = 'success';
var ERROR = 'error';
var WARNING = 'warning';
var INPROGRESS = 'inprogress';
var Root = styled('div')(function (_ref) {
  var _ref$theme = _ref.theme,
    breakpoints = _ref$theme.breakpoints,
    spacing = _ref$theme.spacing,
    palette = _ref$theme.palette;
  return _objectSpread(_objectSpread({
    backgroundColor: palette.primary.dark,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    display: 'flex',
    flexDirection: 'row',
    height: 200,
    justifyContent: 'space-between'
  }, contentSidePadding(breakpoints, spacing)), {}, {
    '& .sovosHeroBanner__leftColumn': {
      display: 'flex',
      flexDirection: 'column'
    }
  });
});
var heroBanners = assetKeys.heroBanners;
var SovosHeroBanner = function SovosHeroBanner(_ref2) {
  var backgroundImage = _ref2.backgroundImage,
    children = _ref2.children,
    className = _ref2.className,
    _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? DEFAULT : _ref2$color,
    _ref2$style = _ref2.style,
    style = _ref2$style === void 0 ? {} : _ref2$style,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var title = findChildByType(children, SovosHeroBannerTitle);
  var subtitle = findChildByType(children, SovosHeroBannerSubtitle);
  var status = findChildByType(children, SovosHeroBannerStatus);
  var image;
  if (backgroundImage) {
    image = backgroundImage;
  } else {
    switch (color) {
      case DARK:
        image = assetResolver.heroBanners(heroBanners.colors.dark);
        break;
      case ERROR:
        image = assetResolver.heroBanners(heroBanners.colors.error);
        break;
      case SUCCESS:
        image = assetResolver.heroBanners(heroBanners.colors.success);
        break;
      case WARNING:
        image = assetResolver.heroBanners(heroBanners.colors.warning);
        break;
      case INPROGRESS:
        image = assetResolver.heroBanners(heroBanners.colors.inProgress);
        break;
      case DEFAULT:
        image = assetResolver.heroBanners(heroBanners.colors.default);
        break;
      default:
        image = undefined;
    }
  }
  var bannerStyle = image ? _objectSpread({
    backgroundImage: "url(".concat(image, ")")
  }, style) : _objectSpread({
    backgroundColor: color
  }, style);
  return /*#__PURE__*/React.createElement(Root, _extends({
    className: clsx('sovosHeroBanner', className),
    "data-testid": "sovosHeroBanner",
    style: bannerStyle
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "sovosHeroBanner__leftColumn"
  }, title, subtitle), /*#__PURE__*/React.createElement("div", {
    className: "sovosHeroBanner__rightColumn"
  }, status));
};
SovosHeroBanner.propTypes = {
  /**
   * Background Image
   */
  backgroundImage: PropTypes.string,
  /**
   * The content of the hero banner. Should be wrapped with
   * `SovosHeroBannerTitle`, `SovosHeroBannerSubtitle`, and `SovosHeroBannerStatus`
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired,
  /**
   * Override or extend the styles applied to the component
   */
  className: PropTypes.string,
  /**
   * Array of color options: default, dark, success, error, warning, and inprogress
   */
  color: PropTypes.oneOfType([PropTypes.oneOf([DEFAULT, DARK, SUCCESS, ERROR, WARNING, INPROGRESS]), PropTypes.string]),
  /**
   * Inline styles applied to the root element
   */
  style: PropTypes.object
};
export default SovosHeroBanner;